import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';

export const useFetchWorkloadReport = () => {
  return useMutation(async (data) => {
    const endPoint = `/api/v1/workloadReport/list`;
    const response = await POST(endPoint, data);
    return response;
  });
};
